module.exports = __webpack_public_path__ + "static/media/suggestions.0e437f71.svg";